const enum IDCheckProviders {
  GBG = 'GBG',
  ONFIDO = 'ONFIDO',
}

export { IDCheckProviders }
